import React, { useState, useEffect } from 'react';
import './AboutUsSection.css';

const aboutTabs = [
  { label: 'ABOUT US', id: 'aboutus' },
  { label: 'TEAM', id: 'team' },
  { label: 'VALUES', id: 'values' },
  { label: 'CONTACT US', id: 'contact-us' },
];

const aboutCards = [
  {
    icon: '/icons/rocket.webp',
    title: 'OUR MISSION',
    text: 'To create seamless technology that fuels digital-first growing companies.',
  },
  {
    icon: '/icons/telescope.webp',
    title: 'OUR VISION',
    text: 'To become a leading company in building a simpler world so people can focus on what matters most.',
  },
];

const stats = [
  { icon: '/icons/atom.webp', value: '2020', label: 'Foundation year' },
  { icon: '/icons/plant.webp', value: '+14', label: 'Years of experience' },
  { icon: '/logos/circle.webp', value: '+300', label: 'Delivered projects' },
  { icon: '/icons/trophy.webp', value: '+50', label: 'Awards & counting' },
  { icon: '/logos/people.webp', value: '100', label: 'Imagineers on board' },
  { icon: '/logos/thumb.webp', value: '99%', label: 'Recommendation rate' },
  { icon: '/logos/meter.webp', value: '78', label: 'Customer NPS score' },
  { icon: '/icons/office.webp', value: '4', label: 'Offices worldwide' },
];

const AboutUsSection = () => {
  const [active, setActive] = useState('aboutus');

  const handleClick = (id) => {
    setActive(id);
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // 🔥 Highlight active section on scroll
  useEffect(() => {
    const handleScroll = () => {
      const offset = 80; // adjust based on your navbar height
      const scrollY = window.scrollY + offset;

      for (let i = aboutTabs.length - 1; i >= 0; i--) {
        const section = document.getElementById(aboutTabs[i].id);
        if (section && section.offsetTop <= scrollY) {
          setActive(aboutTabs[i].id);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // run once on mount

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Sticky Navbar */}
      <nav className="aboutus-sticky-navbar">\
        <div className="container">
        <ul>
          {aboutTabs.map((tab) => (
            <li key={tab.id}>
              <a
                onClick={() => handleClick(tab.id)}
                className={active === tab.id ? 'active' : ''}
                href={"#" + tab.id}
              >
                {tab.label}
              </a>
            </li>
          ))}
        </ul>
        </div>
      </nav>

      <section className="aboutus-section" id="aboutus">
        <div className="aboutus-content-wrapper">
          <div className="container">
            <div id="aboutus" className="aboutus-anchor-section">
              <div className="aboutus-header">
                <span className="aboutus-header-main">
                  WE THINK YOUR DIGITAL PRODUCT
                </span>
                <span className="aboutus-header-highlight">LIKE A USER</span>
              </div>
              <div className="aboutus-cards-row">
                {aboutCards.map((card, idx) => (
                  <div className="aboutus-card" key={idx}>
                    <div className="aboutus-icon">
                      <img src={card.icon} alt={card.title + ' icon'} />
                    </div>
                    <div className="aboutus-card-title">{card.title}</div>
                    <div className="aboutus-card-text">{card.text}</div>
                  </div>
                ))}
              </div>
              <div className="aboutus-stats-grid">
                {stats.map((stat, idx) => (
                  <div className="aboutus-stat-card" key={idx}>
                    <div className="aboutus-icon">
                      <img src={stat.icon} />
                    </div>
                    <div className="aboutus-stat-value">{stat.value}</div>
                    <div className="aboutus-stat-label">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
            {/* Add other anchor sections here: TEAM, VALUES, LIFESTYLE */}
           
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUsSection;
